<div>Bulk Search Summary</div>
<div>   
    <!-- app-bulk-search-results-summary ></app-bulk-search-results-summary -->
</div>